import van, {type State} from "vanjs-core"
import {Net} from "@utils/net";
import {VanUtil as vu} from "@utils/vanUtil";
import {VanComponent} from "@utils/vanComponent";
import {Option} from "@utils/option";
import {LoginState} from "@login/loginState";
import {Busy} from "@commons/layout/busy";
import type {LongDropdownItem} from "hol-dto";
import type {HolLoginResponse} from "hol-dto";
const {div, form, button, h1, h6, label, progress} = van.tags;

type InternalForm = 
{
    orgLocationId: State<number|null>
};

export class LoginLocationSelector extends VanComponent
{
    private readonly locationList: LongDropdownItem[];
    readonly #progress: HTMLElement;
    private readonly form: InternalForm;

    constructor(locationList: LongDropdownItem[])
    {
        super();

        this.locationList = locationList;
        this.form = {
            orgLocationId: van.state()
        };

        this.#progress = Busy.visibility(progress({ "aria-label": "Submitting form" }));
    }

    toDom(): HTMLElement
    {
        return div(this.toDomTags({class: "login-form-pane", style: "padding-bottom: 40px" }),
            div({"class": ""},
                h1({ class: 'login-title' }, 'Select Location'),
                div({"class": ""},
                    form({ onsubmit: event => this.submit(event) },
                        div({class: "mt-3"},
                            label({class: "login-label", for: 'login-selection-location'}, h6('Location')),
                            Option.select(this.form.orgLocationId, 
                                Option.asOptions(this.locationList), 
                                {class: 'login-input form-select', required: 'required', autofocus: true, id: 'login-select-location' }, 
                                '--- Select Location ---'
                            ),
                            vu.load(vu.focalOnLoad)
                        ),
                        div(button({ class: "login-submit", type: 'submit' }, 'Submit')),
                        div({class: "mt-3"}, this.#progress)
                    )
                )
            )
        );
    }

    async submit(event: Event): Promise<void>
    {
        let loginState = LoginState.instance;
        loginState.alert.hide();
        event.preventDefault();     // stops browser from submitting form
        
        if (!this.form.orgLocationId.val)
        {
            loginState.alert.show('You must select a location before submitting');
            return;
        }
        
        let toSubmit = vu.toJS(this.form);
        toSubmit = Object.assign({}, loginState.loginPayload, toSubmit);

        let loginResponse: HolLoginResponse = await Net.post<HolLoginResponse>({ url: '/login/loginWithLocation', data: JSON.stringify(toSubmit) });
        if (loginResponse.hasError)
        {
            loginState.alert.show(loginResponse.errorMessage);
            return;
        }

        loginState.onLocation(loginResponse);
    }
}
